var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "li",
        {
          key: item.itemid,
          staticClass: "cart-item",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.handleEditItem(item.itemid)
            },
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.handleEditItem(item.itemid)
            },
          },
        },
        [
          _c("div", { staticClass: "item-info" }, [
            _c("div", { staticClass: "item-details-section" }, [
              _c("div", { staticClass: "item-title" }, [
                _c(
                  "button",
                  {
                    staticClass: "item-label",
                    attrs: {
                      "aria-label": item.item + ". Click to edit item.",
                      id: item.itemid,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.handleEditItem(item.itemid)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" + _vm._s(item.item) + "\n\t\t\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                item.whofor && item.whofor.trim() !== ""
                  ? _c("ul", { staticClass: "who-for-list" }, [
                      _c("li", [_vm._v("For: " + _vm._s(item.whofor))]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              item.comment
                ? _c("ul", { staticClass: "comment-list" }, [
                    _c("li", [_vm._v(_vm._s(item.comment))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.options.length
                ? _c(
                    "ul",
                    { staticClass: "options-list" },
                    _vm._l(
                      _vm.getFilteredOptions(item.options),
                      function (option) {
                        return _c(
                          "li",
                          { key: option.optionid, staticClass: "item-option" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t+ " +
                                _vm._s(option.option) +
                                "\n\t\t\t\t\t"
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qty-price-section" }, [
            _c("div", { staticClass: "item-price" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm._f("toCurrency")(_vm.itemSubTotal(index))) +
                  "\n\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-quantity-wrapper" }, [
              _c("div", { staticClass: "item-quantity" }, [
                _vm.showQtyTrashIcon(index)
                  ? _c(
                      "button",
                      {
                        staticClass: "item-quantity-delete-button",
                        attrs: {
                          type: "button",
                          "aria-label": "Delete " + item.item + " from cart.",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleRemove(item.itemid)
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleRemove(item.itemid)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fas fa-trash fa-lg item-quantity-delete-icon",
                        }),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "item-quantity-button",
                        attrs: {
                          type: "button",
                          "aria-label":
                            "Decrease Quantity for " +
                            item.item +
                            " from " +
                            item.qty +
                            " to " +
                            (item.qty - 1),
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleQuantityDecrease(
                              index,
                              item.itemid,
                              item.options,
                              item.whofor,
                              item.comment,
                              item.qty
                            )
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleQuantityDecrease(
                              index,
                              item.itemid,
                              item.options,
                              item.whofor,
                              item.comment,
                              item.qty
                            )
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t\t-\n\t\t\t\t\t")]
                    ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "item-quantity-value",
                    attrs: {
                      "aria-label":
                        "Edit Quantity for " +
                        item.item +
                        ". Current quantity " +
                        item.qty,
                    },
                  },
                  [_vm._v(_vm._s(item.qty))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "item-quantity-button",
                    attrs: {
                      type: "button",
                      "aria-label":
                        "Increase Quantity for " +
                        item.item +
                        " from " +
                        item.qty +
                        " to " +
                        (item.qty + 1),
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.handleQuantityIncrease(
                          index,
                          item.itemid,
                          item.options,
                          item.whofor,
                          item.comment,
                          item.qty
                        )
                      },
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.handleQuantityIncrease(
                          index,
                          item.itemid,
                          item.options,
                          item.whofor,
                          item.comment,
                          item.qty
                        )
                      },
                    },
                  },
                  [_vm._v("\n\t\t\t\t\t\t+\n\t\t\t\t\t")]
                ),
              ]),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }